var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { closeMenu } from 'react-aria-menubutton';
import { v4 as uuid } from 'uuid';
import MenuItem from './MenuItem';
import { Box } from '../../Box';
import { addAllyTM } from '../../tools/utils';
import DropdownMenuContext from '../DropdownMenuContext';
import { MenuItemRouterLink } from './MenuItemRouterLink';
import { isExternalURI } from '../../tools/utils/isExternalURI';
const MenuItemLink = (_a) => {
    var { id, href, onSelection, text, content, withAllyTM = true, useRouterLink, className } = _a, props = __rest(_a, ["id", "href", "onSelection", "text", "content", "withAllyTM", "useRouterLink", "className"]);
    const { current: linkUUID } = React.useRef(uuid());
    const safeId = id || `menuItemLink${linkUUID}`;
    const allyTM = addAllyTM({
        content: content !== null && content !== void 0 ? content : text,
        id: safeId,
        elementType: 'interactive',
        withAllyTM,
    });
    const { wrapperId } = React.useContext(DropdownMenuContext);
    const CLOSE_OPTIONS = {
        focusButton: true,
    };
    const onClick = () => {
        onSelection === null || onSelection === void 0 ? void 0 : onSelection();
        closeMenu(wrapperId, CLOSE_OPTIONS);
    };
    const isExternal = typeof href === 'string' && isExternalURI(href);
    const contentInstance = content !== null && content !== void 0 ? content : React.createElement(Box, { color: "bluesuedeshoes" }, text);
    const isRouterLink = typeof href === 'function' ||
        typeof href === 'object' ||
        (useRouterLink && !isExternal);
    if (isRouterLink) {
        return (React.createElement(MenuItemRouterLink, Object.assign({ href: href, onClick: onClick, className: className }, allyTM, props), contentInstance));
    }
    return (React.createElement(MenuItem, Object.assign({ href: href, onClick: onClick, tag: "a", tabIndex: 0, className: className }, allyTM, props), contentInstance));
};
export default MenuItemLink;
//# sourceMappingURL=MenuItemLink.js.map